import React from 'react';

const VARIANT_CLASS = {
  export: 'glass-btn--export',
  primary: 'glass-btn--primary',
  accent: 'glass-btn--accent',
  muted: 'glass-btn--muted',
  secondary: 'glass-btn--secondary',
  refresh: 'glass-btn--muted',
  calendar: 'glass-btn--calendar',
  add: 'glass-btn--add',
  success: 'glass-btn--success',
  info: 'glass-btn--info',
  danger: 'glass-btn--danger',
  purple: 'glass-btn--purple',
};

/**
 * Кнопка в стиле frosted glass (приглушённые оттенки).
 */
const GlassButton = ({
  onClick,
  icon,
  label,
  children,
  variant = 'accent',
  size = 'md',
  active = false,
  disabled = false,
  title,
  type = 'button',
  className = '',
  dataTestId,
}) => {
  const isCalendar = variant === 'calendar';
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.accent;
  const isAccentVariant = ['export', 'primary', 'accent'].includes(variant);
  const stateClass = active
    ? (isCalendar ? 'glass-btn--calendar-active' : isAccentVariant ? 'glass-btn--pressed' : 'glass-btn--active')
    : '';
  const sizeClass = size === 'lg' ? 'glass-btn--lg' : size === 'sm' ? 'glass-btn--sm' : size === 'xs' ? 'glass-btn--xs' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      data-testid={dataTestId}
      className={`glass-btn ${variantClass} ${stateClass} ${sizeClass} ${className}`.trim()}
    >
      {icon != null && (
        <span className="glass-btn__icon" style={{ fontSize: size === 'lg' ? 18 : size === 'xs' ? 11 : 16, lineHeight: 1 }}>
          {icon}
        </span>
      )}
      {(label || children) && <span>{label || children}</span>}
    </button>
  );
};

export default GlassButton;
